import i18next from 'i18next';

i18next.addResources('en', 'FermentationInformationModal', {
  fermentationOperator: 'Fermentation Operator',
  averageHours: 'Average hours of Fermentation'
});
